<template>
  <v-container  class="mx-2">
    <v-row>
      <v-col cols="12" lg="11">
        <v-breadcrumbs class="pl-0 pt-0" :items="items"></v-breadcrumbs>
        <h1 class="mb-4">{{ $route.meta.title }}</h1>
        <v-form ref="formAddAgent" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="8" sm="5" class="pb-0">
              <v-text-field
                label="Юридический адрес"
                v-model='formAgent.legalAddress'
                :rules='rules.universal'
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col cols="8" sm="5" class="pb-0">
              <v-text-field
                label="Фактический адрес"
                v-model='formAgent.actualAddress'
                :rules='rules.universal'
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col cols="8" sm="5" class="py-0">
              <v-text-field
                label="Имя"
                v-model='formAgent.name'
                :rules='rules.universal'
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>
            <v-col cols="8" sm="5" class="py-0">
              <v-text-field
                label="Контактное лицо"
                v-model='formAgent.contact'
                :rules='rules.universal'
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col cols="8" sm="5" class="py-0">
              <v-text-field
                label="ИНН"
                v-model='formAgent.inn'
                :rules='rules.inn'
                type="number"
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col cols="8" sm="5" class="py-0">
              <v-text-field
                label="Диспетчерская"
                v-model='formAgent.dispatcherPhone'
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col cols="8" sm="5" class="py-0">
              <v-text-field
                label="Телефон"
                v-model='formAgent.telephone'
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col cols="8" sm="5" class="py-0">
              <v-text-field
                label="Руководитель"
                v-model='formAgent.supervisor'
                :rules='rules.universal'
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col cols="8" sm="5" class="py-0">
              <v-text-field
                label="Email"
                v-model='formAgent.email'
                :rules='rules.email'
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col cols="8" sm="5" class="py-0">
              <v-text-field
                label="Пароль"
                v-model='formAgent.password'
                :rules='rules.password'
                autocomplete="new-password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                outlined
                dense
                flat
                required
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
              ></v-text-field>
            </v-col>

            <v-col cols="8" sm="5" class="py-0">
              <v-text-field
                label="Подтверждение пароля"
                v-model='formAgent.passwordConfirmation'
                :rules='rules.passwordConfirmation'
                autocomplete="new-password"
                :type="showPassword ? 'text' : 'password'"
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>
          </v-row>

          <v-card-actions class="pl-0">
            <div class="my-2">
              <v-btn
                large
                color="success"
                class="text-none"
                dark
                @click="validate()"
              >
                Сохранить
              </v-btn>
              <v-btn
                @click.prevent="returnAgents()"
                large
                class="ma-2 text-none"
                outlined
                dense
                hide-details
                color="error"

              >
                Отменить
              </v-btn>
            </div>
          </v-card-actions>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'EditAgent',
  data () {
    return {
      valid: true,
      showPassword: false,
      formAgent: {
        name: '',
        email: '',
        inn: '',
        legalAddress: '',
        actualAddress: '',
        contact: '',
        telephone: '',
        dispatcherPhone: '',
        supervisor: '',
        password: '',
        passwordConfirmation: '',
      },
      rules: {
        universal: [
          v => !!v || 'Поле обязательно для заполнения',
        ],
        email: [
          v => /.+@.+\..+/.test(v) || 'E-mail должен быть корректным',
        ],
        inn: [
          v => v ? (v.length > 5 && v.length < 11) || 'ИНН должен быть от 6  до 10 цифр' : true,
        ],
        telephone: [
          v => /^\d{11}$/.test(v) || 'Укажите корректный номер телефона',
        ],
        password: [
          v => v ? v.length > 5 || 'Пароль должен быть не менее 6 символов' : true,
        ],
        passwordConfirmation: [
          v => v ? v.length > 5 || 'Пароль должен быть не менее 6 символов' : true,
          v => v ? v === this.formAgent.password || 'Пароли не совпадают' : true,
        ],
      },
      items: [
        {
          text: 'Агенты',
          disabled: false,
          href: '/agents',
        },
        {
          text: ' Редактирование агента',
          disabled: true,
          href: 'breadcrumbs_link_1',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      agent: 'Agents/agent',
    }),
  },
  methods: {
    ...mapActions({
      loadAgent: 'Agents/loadAgent',
      updateAgent: 'Agents/updateAgent',
      loadAllAgents: 'Agents/loadAllAgents',
    }),

    returnAgents () {
      this.$router.push({ name: 'Agents' });
    },

    validate () {
      if (this.$refs.formAddAgent.validate()) {
        const tempAgent = {
          name: this.formAgent.name,
          email: this.formAgent.email,
          legal_address: this.formAgent.legalAddress,
          actual_address: this.formAgent.actualAddress,
          contact: this.formAgent.contact,
          telephone: this.formAgent.telephone,
          dispatcher_phone: this.formAgent.dispatcherPhone,
          supervisor: this.formAgent.supervisor,
        };

        if (this.formAgent.password) {
          tempAgent.password = this.formAgent.password;
        }
        if (this.formAgent.passwordConfirmation) {
          tempAgent.password_confirmation = this.formAgent.passwordConfirmation;
        }
        if (this.formAgent.inn) {
          tempAgent.inn = this.formAgent.inn;
        }

        this.updateAgent({
          id: this.$route.params.id,
          agent: tempAgent,
        })
          .then(() => {
            this.loadAllAgents();
            this.$router.push({ name: 'Agents' });
            this.$flash_success('Изменения успешно сохранены');
          })
          .catch((err) => {
            if (err.message.includes('422')) {
              const response = err.response.data;
              for (const input in response) {
                response[input].forEach(error => this.$flash_warning(input + ': ' + error));
              }
            } else {
              this.$flash_warning('Ошибка при создании агента');
            }
          });
      }
    },
  },
  created () {
    this.loadAgent(this.$route.params.id)
      .then(() => {
        this.formAgent.name = this.agent.user.name;
        this.formAgent.email = this.agent.user.email;
        // if (this.agent.inn) {
        //   this.formAgent.inn = this.agent.inn;
        // }
        // this.formAgent.inn = this.agent
        this.formAgent.legalAddress = this.agent.legal_address;
        this.formAgent.actualAddress = this.agent.actual_address;
        this.formAgent.contact = this.agent.contact;
        this.formAgent.telephone = this.agent.telephone;
        this.formAgent.dispatcherPhone = this.agent.dispatcher_phone;
        this.formAgent.supervisor = this.agent.supervisor;
      });
  },
};
</script>
